/* global angular, FB */
angular.module('ua5App')
    .directive('facebook', ['$location', function($location) {
        return {
            restrict: 'A',
            scope: {
                url: '@'
            },
            link: function($scope, $element, $attrs) {
                $element.on('click', function(e) {
                    var url;
                    url = $attrs.url || $location.absUrl();
                    e.preventDefault();
                    FB.ui({
                        method: 'share',
                        // Share the current page's URL if none specified
                        href: url
                    });
                });
                $scope.$on('$destroy', function() {
                    $element.off('click');
                });
            }
        };
    }])

    .factory('FacebookService', ['$window', function($window) {
        return {
            init: function(appId) {
                if (appId) {
                    $window.fbAsyncInit = function() {
                        FB.init({
                            appId: appId,
                            status: true,
                            xfbml: true
                        });
                    };
                    (function(d) {
                        var id;
                        var js;
                        var ref;
                        id = 'facebook-jssdk';
                        ref = d.getElementsByTagName('script')[0];
                        if (d.getElementById(id)) {
                            return;
                        }
                        js = d.createElement('script');
                        js.id = id;
                        js.async = true;
                        js.src = '//connect.facebook.net/en_US/all.js';
                        ref.parentNode.insertBefore(js, ref);
                    }(document));
                } else {
                    throw('FB appId cannot be blank!');
                }
            }
        };
    }])
;
